'use client';

import { VIDEO_SOURCE_TYPE } from '@/constants/videoSource';

import { BackgroundVideoFile } from './BackgroundVideoFile';
import { BackgroundVideoYouTube } from './BackgroundVideoYouTube';

import type { BackgroundVideoProps } from './backgroundVideo.shared';

export type {
  BackgroundVideoFileVariant,
  BackgroundVideoPoster,
  BackgroundVideoProps,
  BackgroundVideoSource,
} from './backgroundVideo.shared';
export { BackgroundVideoFile } from './BackgroundVideoFile';
export { BackgroundVideoYouTube } from './BackgroundVideoYouTube';

/**
 * Reusable full-bleed background video. Pass a discriminated `source` — YouTube
 * or a self-hosted file — plus a responsive `poster` for LCP-safe loading.
 * The root fills its nearest positioned ancestor; supply `className` for any
 * section-specific placeholder styling.
 */
export function BackgroundVideo({ source, poster, className }: BackgroundVideoProps) {
  switch (source.type) {
    case VIDEO_SOURCE_TYPE.YOUTUBE:
      return <BackgroundVideoYouTube videoId={source.videoId} poster={poster} className={className} />;
    case VIDEO_SOURCE_TYPE.FILE:
      return (
        <BackgroundVideoFile
          variants={source.variants}
          poster={poster}
          className={className}
        />
      );
  }
}
